export default {
  item1Title: {
    id: 'product_page_upgrage_modal_item1_title',
    defaultMessage: 'Current picks',
  },
  item2Title: {
    id: 'product_page_upgrage_modal_item2_title',
    defaultMessage: 'Smart upgrade',
  },
  youSave: {
    id: 'product_page_upgrage_modal_save_amount',
    defaultMessage: 'Save {amount}',
  },
}
